export const initialState = {
  bulkAdwordsKeywords: void 0,
  knowledgeGraph: void 0,
};
